import * as yup from 'yup'

export const orderTrackerConfigSchema = yup.object({
  baseUrl: yup
    .string()
    .trim()
    .url('Invalid Order Tracker Base URL')
    .required('Order Tracker Base URL is required'),
  serviceApiToken: yup
    .string()
    .trim()
    .required('Service API Token is required'),
  syncWebhookToken: yup
    .string()
    .trim()
    .required('Picker Sync Token is required'),
  cacheTtlSeconds: yup
    .number()
    .typeError('Must be a number')
    .integer()
    .min(1, 'Min 1 second')
    .max(3600, 'Max 3600 seconds')
    .required('Session cache time is required'),
  requestTimeoutMs: yup
    .number()
    .typeError('Must be a number')
    .integer()
    .min(1000, 'Min 1000 ms')
    .max(60000, 'Max 60000 ms')
    .required('Request timeout is required'),
  allowLegacyLogin: yup.boolean().required(),
})

export type OrderTrackerConfigFormFields = yup.InferType<
  typeof orderTrackerConfigSchema
>
